import axios from "axios";
import { env } from "../constants/env";
import { db } from "./offlineDB";

export const syncOfflineAuditSummaries = async (token) => {
  if (!navigator.onLine) return;

  const allSummaries = await db.offlineAuditSummaries.toArray();
  console.log("[SYNC] Checking offline audit summaries", allSummaries);

  for (const summary of allSummaries) {
    const {
      id,
      labId,
      labName,
      hpczLicense,
      sections,
      totalScore,
      stars,
      offline,
      timestamp,
      lastSynced,
    } = summary;

    // Only sync offline records
    if (!offline) continue;

    try {
      // Transform sections array to object: { "Section Name": score }
      const sectionsPayload = sections.reduce((acc, s) => {
        acc[s.section] = Number(s.score || 0);
        return acc;
      }, {});

      const payload = {
        labId,
        labName,
        hpczLicense,
        sections: sectionsPayload, // send as object
        totalScore,
        stars,
      };

      const res = await axios.post(
        `${env.kataApiUrl}/api/certification/audit-summary/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const serverData = res.data.auditSummary || res.data.data;

      // Remove offline record if POSTed
      if (id.startsWith("offline-")) {
        await db.offlineAuditSummaries.delete(id);
      }

      // Save synced version locally
      await db.offlineAuditSummaries.put({
        ...serverData,
        id: serverData._id,
        labId: serverData.labId,
        labName: serverData.labName,
        hpczLicense: serverData.hpczLicense,
        offline: false,
        lastSynced: new Date().toISOString(),
        timestamp: Date.now(),
      });

      console.log(`[SYNC] Audit summary synced: ${serverData._id}`);
    } catch (err) {
      console.error(`[SYNC] Failed audit summary ${id}:`, err.message);
    }
  }
};